import React, { useState } from 'react'
import { useBilling } from '../../../hooks'

import { InvoiceList } from '../../../components/InvoiceList/InvoiceList'
import { toast } from 'react-toastify'

export const InvoiceListPage = () => {
    const [selected, setSelected] = useState<string[]>([])
    const [selectAllRows, setSelectAllRows] = useState(false)
    const [isDashboardOpen, setIsDashboardOpen] = useState(false)
    const [currentPageInvoiceIds, setCurrentPageInvoiceIds] = useState<
        string[]
    >([])
    const [totalCount, setTotalCount] = useState(0)

    const { bulkSendInvoices, markReviewed } = useBilling({
        limit: 50,
        offset: 0,
        sort: 'invoice_number',
        all_properties: true,
        isAdmin: true,
    })

    const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            // Select all items on current page
            setSelectAllRows(false)
            // Add current page items to selected (merge with existing selections)
            const newSelected = Array.from(
                new Set([...selected, ...currentPageInvoiceIds]),
            )
            setSelected(newSelected)
        } else {
            // Deselect all items on current page
            setSelectAllRows(false)
            const newSelected = selected.filter(
                (id) => !currentPageInvoiceIds.includes(id),
            )
            setSelected(newSelected)
        }
    }

    const handleSelectAllPages = () => {
        if (!selectAllRows) {
            setSelectAllRows(true)
        } else {
            setSelectAllRows(false)
            setSelected([])
        }
    }

    const handleSelectOne = (id: string) => {
        const selectedIndex = selected.indexOf(id)
        let newSelected: string[] = []

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id)
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1))
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1))
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            )
        }

        setSelected(newSelected)
    }

    return (
        <InvoiceList
            selectedInvoices={selected}
            selectAllRows={selectAllRows}
            onSelectAll={handleSelectAll}
            onSelectOne={handleSelectOne}
            onSelectAllPages={handleSelectAllPages}
            isAdmin={true}
            allPagesSelected={selectAllRows}
            onCurrentPageInvoicesChange={setCurrentPageInvoiceIds}
            onTotalCountChange={setTotalCount}
            onSendInvoices={() => {
                if (selected.length > 0) {
                    bulkSendInvoices({
                        invoiceIds: selected.map((id) => parseInt(id)),
                        includeAll: selectAllRows,
                    })
                }
            }}
            onMarkReviewed={() => {
                if (selected.length > 0) {
                    console.log('selected', selected)
                    // markReviewed({
                    //     invoiceIds: selected.map((id) => parseInt(id)),
                    // }).then(() => {
                    //     toast.success('Invoices marked as reviewed')
                    // })
                }
            }}
            visibleColumns={[
                'invoice_number',
                'billing_group_display_name',
                'billing_email',
                'status',
                'issue_date',
                'due_date',
                'total_amount',
                'balance_due',
            ]}
            isDashboardOpen={isDashboardOpen}
            onToggleDashboard={() => setIsDashboardOpen(!isDashboardOpen)}
            setSelectedInvoices={setSelected}
        />
    )
}
